import { Card as HeroCard } from "@heroui/react";
import { cn } from "@/lib/cn";

export function Card({
  className,
  children,
  ...rest
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <HeroCard
      variant="default"
      className={cn("card border-0 p-0", className)}
      {...rest}
    >
      {children}
    </HeroCard>
  );
}

export function CardHeader({
  title,
  subtitle,
  action,
  className,
}: {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  action?: React.ReactNode;
  className?: string;
}) {
  return (
    <HeroCard.Header
      className={cn(
        "flex items-start justify-between gap-3 px-5 pb-0 pt-5 sm:px-6 sm:pt-6",
        className,
      )}
    >
      <div>
        <HeroCard.Title className="text-[15px] font-extrabold text-ink-1">
          {title}
        </HeroCard.Title>
        {subtitle && (
          <HeroCard.Description className="mt-0.5 text-[11px] text-ink-3">
            {subtitle}
          </HeroCard.Description>
        )}
      </div>
      {action}
    </HeroCard.Header>
  );
}
